import { useState, useEffect } from 'react';

import Container from '@mui/material/Container';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { modelApis } from '../../../apis/modelApis';
import AlertMessage from '../../../components/elements/alert-message/AlertMessage';
import Loading from '../../../components/elements/loading/Loading';
import Breadcrumbs from '../../../components/sections/breadcrumbs/Breadcrumbs';
import InstanceInfo from '../../../components/sections/overview/InstanceInfo';
import Overview from '../../../components/sections/overview/Overview';

const ModelOverviewPage = () => {
  const { projectId, modelId } = useParams();
  const { t } = useTranslation();

  const [model, setModel] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const { data: modelRes } = await modelApis.getModel(projectId, modelId);
      setModel(modelRes);
    } catch (error) {
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (loading) return <Loading />;

  if (error)
    return (
      <AlertMessage
        severity="error"
        message={t('fetchModelError', { ns: 'notifications' })}
      />
    );

  return (
    <Container>
      <Breadcrumbs modelName={model?.name} />
      <Overview data={model} />
      <InstanceInfo instance={model} />
    </Container>
  );
};

export default ModelOverviewPage;
